export { default as Root } from "./components/avatar.svelte";
export { default as Image } from "./components/avatar-image.svelte";
export { default as Fallback } from "./components/avatar-fallback.svelte";
export * from "./types.js";
